import React from 'react'
import { Slide, SnackbarProps } from '@material-ui/core'

/**
 * https://v4.mui.com/components/snackbars/#control-slide-direction
 * @param props
 * @constructor
 */
export function TransitionUp(
  props: JSX.IntrinsicAttributes & SnackbarProps
): JSX.Element {
  return <Slide {...props} direction="up" />
}
